'use strict';
/**
 * @author Romatel
 */
export default ['$resource', function($resource) {
    return $resource('api/operationtypes/:typeId', { typeId: "@id"}, {
        getAll: {method: 'GET'},
        get: {method: 'GET'},
        create: {url: 'api/operationtypes', method: 'POST'},
        update: {url: 'api/operationtypes/:typeId', method: 'PUT'},
        delete: {url: 'api/operationtypes/:typeId', method: 'DELETE'},
    });
}];
